import styled from 'styled-components'

export const BoxedContent = styled.div`
  width: 100%;
  max-width: ${(props) => props.theme.sizes.desktop}px;
  margin: 0 auto;
`
